import {Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, OnChanges, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-net-select',
  templateUrl: './net-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: NetSelectComponent
    }
  ]
})
export class NetSelectComponent implements OnInit, OnChanges, ControlValueAccessor  {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Input()
  jump:boolean = true;

  @Output()
  netIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  netId:any;

  @Input()
  placeholder:any = 'NW.TYPE';

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any;

  @Input()
  showAllOption:boolean = false;

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[];

  onChange = (netId) => {};
  onTouched = () => {};
  touched = false;

  change(e) {
    this.onChange(e);
    this.netIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(netId: string): void {
    this.netId = netId;
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  reload() {
    let params:HttpParams = new HttpParams();

    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/domain/nets/all`, {params:params})
        .subscribe(data => {
          this.options = data as any[]
          this.sel.loading = false;
        });
  }

  ngOnInit(): void {
    this.reload();
  }
}
